<script setup lang="ts">
/**
 * AppImage — kit-compliant image element.
 *
 * Default mode (`preview="false"`): renders a plain <img>. Class/style fall
 * through to the image itself, so callers can size and style normally.
 *
 * Preview mode (`preview="true"`): delegates to PrimeVue Image for zoom +
 * lightbox. Used by Galleria and full-screen viewers.
 *
 * Splitting on `preview` keeps the simple case simple: ordinary thumbnails
 * and logos don't pay the wrapper-span cost that breaks `.foo { max-width }`.
 */
import PrimeImage from 'primevue/image'

interface Props {
  src: string
  alt?: string
  width?: string | number
  height?: string | number
  preview?: boolean
  imageClass?: string
}

withDefaults(defineProps<Props>(), {
  alt: '',
  preview: false,
})
</script>

<template>
  <PrimeImage
    v-if="preview"
    :src="src"
    :alt="alt"
    :width="width"
    :height="height"
    :preview="true"
    :imageClass="imageClass"
  />
  <img v-else :src="src" :alt="alt" :width="width" :height="height" :class="imageClass" />
</template>
